import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'
import { getShortCodeValue } from 'functions/replaceTextShortCodes'

// eslint-disable-next-line import/no-cycle
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')
const findInputIndex = items => items.findIndex(item => item.item_type === 'input')
const findTextBlockIndex = items => items.findIndex(item => item.item_type === 'text')

const renderItems = (container, array, callbacks) => array.map((item) => {
  const { key, label, required } = item

  // Clone the container so we can modify its items
  const mergedContainer = JSON.parse(JSON.stringify(container))

  // Find the first label and change its value to the input's label
  const textBlockIndex = findTextBlockIndex(container.items)
  if (textBlockIndex !== -1){
    const textBlock = mergedContainer.items[textBlockIndex]

    mergedContainer.items.splice(textBlockIndex, 1, {
      ...textBlock,
      data: {
        ...textBlock.data,
        value: label,
      },
    })
  }

  // Find the input and merge the props
  const inputIndex = findInputIndex(container.items)
  if (inputIndex !== -1){
    const input = mergedContainer.items[inputIndex]

    mergedContainer.items.splice(inputIndex, 1, {
      ...input,
      options: {
        ...input.options,
        inputDataStoreKey: key,
        inputDataStoreLabel: required ? `* ${label}` : label,
        inputRequired: required,
      },
    })
  }

  return (
    // eslint-disable-next-line react/no-array-index-key
    <div key={key} style={deviceStyle(mergedContainer)}>
      <ElementContainer
        callbacks={callbacks}
        forwardContextToItems={item}
        section={mergedContainer}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    </div>
  )
})

const DynamicInputs = (props) => {
  const {
    callbacks,
    context: componentContext,
    items,
  } = props

  // Context
  const defaultContext = useContext(GlobalContext)
  const contextData = { ...defaultContext, ...componentContext }

  const array = getShortCodeValue('{{digitalPage.options.dynamic_inputs}}', contextData, { returnRawValue: true })

  // Check if the array is actually an array (or object is js)
  if (!array || !Array.isArray(array)) return null

  const container = findContainer(items) || {}

  return renderItems(container, array, callbacks)
}

DynamicInputs.propTypes = {
  context: PropTypes.object,
  data: PropTypes.object,
  items: PropTypes.array,
}

DynamicInputs.defaultProps = {
  data: {},
  options: {},
}

export default DynamicInputs
